export default __webpack_public_path__ + "static/media/gcash_coming_soon.bb933608.png";